import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import { generatePath, Link } from 'react-router-dom';
import {
  AchievementIcon,
  ApplicationIcon,
  DocumentIcon,
  EducationIcon,
  FamilyIcon,
  HeartIcon,
  LogoutIcon,
  ProfileIcon,
  WorkIcon,
} from '../../../assets/icons';
import { APP_URLS } from '../../../routes/urls';
import { openQualificationDrawer, showBackButton } from '../../../store/features/qualification/qualificationSlice';
import { useAppDispatch } from '../../../store/hooks';
import { AppIcon } from '../../app-icon/AppIcon';
import { accountMenuStyles } from './styles';

interface DesktopProfileMenuProps {
  menuAnchorEl: HTMLElement | null;
  isMenuOpen: boolean;
  toggleIsMenuOpen: () => void;
  signOut: () => void;
  slug: string;
}
export const DesktopProfileMenu: React.FC<DesktopProfileMenuProps> = ({
  menuAnchorEl,
  isMenuOpen,
  signOut,
  toggleIsMenuOpen,
  slug,
}) => {
  /**
   * URLS to student profiles pages
   */
  const urlParams = { studentSlug: slug };
  const viewProfileUrl = generatePath(APP_URLS.profile, urlParams);
  const viewFamilyUrl = generatePath(APP_URLS.familyInfo, urlParams);
  const viewEducationUrl = generatePath(APP_URLS.educationInfo, urlParams);
  const viewAchievementUrl = generatePath(APP_URLS.achievementInfo, urlParams);
  const viewWorkUrl = generatePath(APP_URLS.workInfo, urlParams);
  const viewWishlistUrl = generatePath(APP_URLS.wishlistInfo, urlParams);
  const viewDocumentUrl = generatePath(APP_URLS.documentInfo, urlParams);
  const viewApplicationUrl = generatePath(APP_URLS.applicationInfo, urlParams);

  const dispatch = useAppDispatch();
  const onManageQualificationBtnClick = (): void => {
    dispatch(showBackButton());
    dispatch(openQualificationDrawer());
  };

  return (
    <Menu
      PaperProps={{
        sx: accountMenuStyles.profileMenu,
      }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorEl={menuAnchorEl}
      open={isMenuOpen}
      onClose={toggleIsMenuOpen}
      onClick={toggleIsMenuOpen}
    >
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewProfileUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={ProfileIcon} titleAccess="View Profile" />
        </ListItemIcon>
        View Profile
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewFamilyUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={FamilyIcon} titleAccess="View Family Details" />
        </ListItemIcon>
        Family Details
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewEducationUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={EducationIcon} titleAccess="View Education Details" />
        </ListItemIcon>
        Education
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewAchievementUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={AchievementIcon} titleAccess="View Achievements" />
        </ListItemIcon>
        Achievements
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewWorkUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={WorkIcon} titleAccess="View Work Experience" />
        </ListItemIcon>
        Work Experience
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewWishlistUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={HeartIcon} titleAccess="View Wishlists" />
        </ListItemIcon>
        Wishlists
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewDocumentUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={DocumentIcon} titleAccess="View Documents" />
        </ListItemIcon>
        Documents
      </MenuItem>
      <MenuItem
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
        component={Link}
        to={viewApplicationUrl}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={ApplicationIcon} titleAccess="View Applications" />
        </ListItemIcon>
        My Applications
      </MenuItem>
      <MenuItem
        onClick={onManageQualificationBtnClick}
        sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]}
      >
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={EducationIcon} titleAccess="Manage Qualification" />
        </ListItemIcon>
        Manage qualification
      </MenuItem>
      <MenuItem sx={[accountMenuStyles.accountMenuItem, accountMenuStyles.profileMenuItem]} onClick={signOut}>
        <ListItemIcon sx={accountMenuStyles.profileMenuIcon}>
          <AppIcon fontSize="small" Icon={LogoutIcon} titleAccess="Signout" />
        </ListItemIcon>
        Sign Out
      </MenuItem>
    </Menu>
  );
};
